export const MIN_RATING_TO_SKIP_FEEDBACK_DETAILS = 4;
export const USER_RATE_KEY = 'USER_RATE_KEY';
export const INITIAL_RATING = 0;
export const STARS = 5;
